import { NgModule } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { HRComponent } from './hr.component';
import { DashboardComponent } from './selfService/dashboard.component';
import { EmployeeComponent } from './employee/employee.component';
import { ViewEmployeesComponent } from './employee/viewEmployees.component';
import { HrConfigComponent } from './hrConfig/hrConfig.component';
import { ReportingComponent } from './reporting/reporting.component';
import { PSCComponent } from './psc/psc.component';
import { PscGenerateFiscalPayComponent } from './psc/pscGenerateFiscalPay.component';
import { PscWsLeadReviewQueueComponent } from './psc/pscWsLeadReviewQueue.component';
import { PscDmApprovalQueueComponent } from './psc/pscDmApprovalQueue.component';
import { PscHrmApprovalQueueComponent } from './psc/pscHrmApprovalQueue.component';
import { PscPmmApprovalQueueComponent } from './psc/pscPmmApprovalQueue.component';
import { PscAcctReceivalQueueComponent } from './psc/pscAcctReceivalQueue.component';
import { PscItReceivalQueueComponent } from './psc/pscItReceivalQueue.component';
import { PscHrRoutingQueueComponent } from './psc/pscHrRoutingQueue.component';
import { PscHrRejectedQueueComponent } from './psc/pscHrRejectedQueue.component';
import { PscHrmRejectedQueueComponent } from './psc/pscHrmRejectedQueue.component';
import { PscHrAcceptedQueueComponent } from './psc/pscHrAcceptedQueue.component';
import { PscHrmAcceptedQueueComponent } from './psc/pscHrmAcceptedQueue.component';
import { PscAcctReceivedQueueComponent } from './psc/pscAcctReceivedQueue.component';
import { EmployeeTrainingComponent } from './training/employeeTraining.component';
import { MyTrainingComponent } from './training/myTraining.component';
import { TrainingConfigComponent } from './trainingConfig/trainingConfig.component';
import { SelfTrainedCertQueueComponent } from './trainingReview/selfTrainedCertQueue';
import { TrainerCertQueueComponent } from './trainingReview/trainerCertQueue';
import { QualApprovalQueueComponent } from './trainingReview/qualApprovalQueue';
import { ReportingTrainingComponent } from './reporting/reportingTraining.component';
import { AuthGuard } from '../../../../src/app/guards/auth.guard';

const hrRoutes: Routes = [
  {
    path: "",
    component: HRComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: './', redirectTo: "", pathMatch: "full" },
          { path: '', component: DashboardComponent },
          { path: 'employee', component: EmployeeComponent },
          { path: 'employee/:empId', component: EmployeeComponent },
          { path: 'viewEmployees', component: ViewEmployeesComponent },
          { path: 'hrConfig', component: HrConfigComponent },
          { path: 'reporting', component: ReportingComponent },
          { path: 'newPsc/:empId', component: PSCComponent },
          { path: 'selfServicePsc/:routedFrom', component: PSCComponent },
          { path: 'dmSelfServicePsc/:routedFrom/:dmSsEmpId', component: PSCComponent },
          { path: 'psc/:pscId/:routedFrom', component: PSCComponent },
          { path: 'psc/:pscId', component: PSCComponent },
          { path: 'pscGenerateFiscalPay', component: PscGenerateFiscalPayComponent},
          { path: 'pscWsLeadReview', component: PscWsLeadReviewQueueComponent },
          { path: 'pscDmApproval', component: PscDmApprovalQueueComponent },
          { path: 'pscHrmApproval', component: PscHrmApprovalQueueComponent },
          { path: 'pscPmmApproval', component: PscPmmApprovalQueueComponent },
          { path: 'pscAcctReceival', component: PscAcctReceivalQueueComponent },
          { path: 'pscItReceival', component: PscItReceivalQueueComponent },
          { path: 'pscHrRouting', component: PscHrRoutingQueueComponent },
          { path: 'pscHrRejected', component: PscHrRejectedQueueComponent },
          { path: 'pscHrmRejected', component: PscHrmRejectedQueueComponent },
          { path: 'pscHrAccepted', component: PscHrAcceptedQueueComponent },
          { path: 'pscHrmAccepted', component: PscHrmAcceptedQueueComponent },
          { path: 'pscAcctReceived', component: PscAcctReceivedQueueComponent },
          { path: 'employeeTraining', component: EmployeeTrainingComponent },
          { path: 'myTraining', component: MyTrainingComponent },
          { path: 'trainingConfig', component: TrainingConfigComponent },
          { path: 'selfTrainedCert', component: SelfTrainedCertQueueComponent },
          { path: 'trainerCert', component: TrainerCertQueueComponent },
          { path: 'qualApproval', component: QualApprovalQueueComponent },
          { path: 'reportingTraining', component: ReportingTrainingComponent }
       ]
      }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(hrRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class HRRoutingModule { }
